import React from "react";
import {Col, Row} from "antd";
import data from "./data";

const Videos : React.FC = () => {
    return (
        <section id={"videos"} className={"main-videos"}>
            <div className={"public-container"}>
                <Row gutter={[50, 10]}>
                    <Col md={8} sm={24} xs={24}>
                        <div className={"section-heading"}>
                            <h2 className={"title"}>{data.videos.id.title}</h2>
                            <p className={"subtitle"}>{data.videos.id.subTitle}</p>
                        </div>
                    </Col>
                    <Col md={16} sm={24} xs={24}>
                        <video width="100%" controls style={{borderRadius: "10px"}}>
                            {
                                [1, 2, 3, 4].map(item => (
                                    <source key={item} src={`/videos/${item}.mp4`} type="video/mp4" />
                                ))
                            }
                        </video>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(Videos);